import Gravity from '../../../../../gravity-global/assets/js/global-functions';
import { addSlidesTabIndex } from '../../../../../gravity-global/assets/js/helpers/swiper/add-slides-tab-index';

const buttonCarouselInit = () => {
    document
        .querySelectorAll('.gg-button-carousel .wp-block-statik-slider > .swiper')
        /* eslint-disable */
        .forEach((buttonCarousel) => {
            buttonCarousel.swiper.params.watchSlidesProgress = true;
            buttonCarousel.swiper.params.grabCursor = true;
            buttonCarousel.swiper.params.observer = true;
            buttonCarousel.swiper.params.observerParents = true;
            buttonCarousel.swiper.params.breakpoints = {
                /* eslint-enable */
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 24,
                },
                600: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },
                800: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            };

            buttonCarousel.swiper.update();

            addSlidesTabIndex(buttonCarousel.swiper);

            buttonCarousel.swiper.on('slideChange', () => {
                addSlidesTabIndex(buttonCarousel.swiper);
            });

            const observer = new IntersectionObserver(
                // eslint-disable-next-line no-shadow
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            animateVisibleSlides(buttonCarousel);
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 0.4 }
            );

            observer.observe(buttonCarousel);
        });
};

const animateVisibleSlides = (swiper) => {
    const visibleSlides = swiper.swiper.slides.filter((slide) =>
        slide.classList.contains('swiper-slide-visible')
    );

    visibleSlides.forEach((slide, index) => {
        // eslint-disable-next-line no-param-reassign
        slide.style.transition = `opacity 1.5s ${index * 0.3}s`;
        // eslint-disable-next-line no-param-reassign
        slide.style.opacity = 1;
    });

    setTimeout(() => {
        swiper.classList.add('animation-end');
    }, visibleSlides.length * 300);
};


Gravity.ready(buttonCarouselInit);
